import { z } from 'zod';

/**
 * One envelope for every response, so the client has a single shape to handle.
 * `ok` discriminates the union — never inspect `data` without checking it.
 */
export const ApiError = z.object({
  code: z.string(),
  message: z.string(),
  /** Field-level detail from schema validation, when relevant. */
  details: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
});
export type ApiError = z.infer<typeof ApiError>;

export function apiSuccess<T>(data: T): { ok: true; data: T } {
  return { ok: true, data };
}

export function apiFailure(error: ApiError): { ok: false; error: ApiError } {
  return { ok: false, error };
}

export type ApiResponse<T> = { ok: true; data: T } | { ok: false; error: ApiError };

export const HealthStatus = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string(),
  env: z.string(),
  uptimeSeconds: z.number(),
  checks: z.object({
    database: z.enum(['ok', 'unavailable']),
  }),
});
export type HealthStatus = z.infer<typeof HealthStatus>;

export const ERROR_CODES = {
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  NOT_FOUND: 'NOT_FOUND',
  SQUAD_ILLEGAL: 'SQUAD_ILLEGAL',
  UPSTREAM_UNAVAILABLE: 'UPSTREAM_UNAVAILABLE',
  AI_UNAVAILABLE: 'AI_UNAVAILABLE',
  RATE_LIMITED: 'RATE_LIMITED',
  INTERNAL: 'INTERNAL',
} as const;
export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES];
